module.exports = __webpack_public_path__ + "img/pc_func4.45a9a6e9.png";